import { firestoreDb } from './firebase';
import {
    collection,
    query,
    orderBy,
    onSnapshot,
    deleteDoc,
    doc
} from 'firebase/firestore';

class FirebaseReceiver {
    constructor(sessionId) {
        // console.log('sessionId:', sessionId, typeof sessionId);  // should be string
        const cmdsCol = collection(firestoreDb, 'commands', sessionId, 'commands');
        const q = query(cmdsCol, orderBy('createdAt'));
        this.unsubscribe = onSnapshot(q, snap => {
            snap.docChanges().forEach(change => {
                if (change.type === 'added') {
                    const { command, payload } = change.doc.data();
                    this.handleCommand(command, payload);
                    deleteDoc(doc(cmdsCol, change.doc.id));
                }
            });
        });
        this.commands = {};
    }

    handleCommand(command, payload) {
        // console.log('Received command:', command, payload);
        if (this.commands[command]) {
            this.commands[command](payload);
        } else {
            console.warn(`No handler for command: ${command}`);
        }
    }

    tearDown() {
        this.unsubscribe();
    }

    setCommand(command, action) {
        this.commands[command] = action;
    }
}

export default FirebaseReceiver;